export const errors = {
  generic: 'Oops something went wrong, try again. If the problem persists feel free to contact us.',
  jobRequestUnavailable: 'We couldn\'t load this job.',
  customerUnavailable: 'We couldn\'t load this company.',
  imageUpload: 'We couldn\'t upload that image. Use a JPG, PNG, GIF, WebP or HEIC file under 40 MB.',
};

export default errors;
